import '@helix-ds/tokens/css'
import '@helix-ds/react/styles.css'
import '@/styles/globals.css'
import { Button } from '@helix-ds/react'
import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initializeSentry } from './sentry.config'

// Initialize Sentry as early as possible
initializeSentry()

// Dark mode is temporarily disabled until rendering issues are fixed.
// helix-exception: dark mode forced off; Helix default theme ships no dark tokens (F-14)
document.documentElement.classList.remove('dark')
document.documentElement.style.colorScheme = 'light'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary
        fallback={({ error, resetError }) => (
          <div className="flex min-h-screen items-center justify-center bg-background-variant-gray px-4 dark:bg-gray-950">
            <div className="w-full max-w-md rounded-base border border-border-base bg-background-primary p-8 text-center shadow-xl dark:border-gray-700 dark:bg-gray-900">
              <h1 className="mb-4 text-2xl font-bold text-error-600 dark:text-error-100">Something went wrong</h1>
              <p className="mb-4 text-text-body dark:text-gray-400">
                {error instanceof Error ? error.message : 'Please refresh the page to try again.'}
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                <Button
                  variant="primary"
                  size="md"
                  type="button"
                  onClick={resetError}
                  className="focus-visible:ring-brand-600"
                >
                  Try again
                </Button>
                <button
                  type="button"
                  onClick={() => window.location.reload()}
                  className="rounded-full border border-border-base bg-background-secondary-medium px-4 py-2 text-sm font-medium text-text-body transition-colors hover:bg-background-tertiary focus:outline-none focus:ring-4 focus:ring-brand-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
                >
                  Refresh page
                </button>
              </div>
            </div>
          </div>
        )}
        showDialog
      >
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
)
